import ServiceBase from './serviceBase';
import { CustomFilterForm, SaveCustomFilter } from './types/CustomFilter';

class CustomFilterService extends ServiceBase {
  getMetadata = async (): Promise<CustomFilterForm> =>
    this.get<CustomFilterForm>('/operations/initialDataCustomFilter');

  saveCustomFilter = async (payload: SaveCustomFilter): Promise<SaveCustomFilter> =>
    this.post<SaveCustomFilter>('customFilters', payload);

  deleteCustomFilter = async (customFilterId: number): Promise<boolean> => {
    const url = `customFilters/${customFilterId}`;
    await this.delete(url);
    return true;
  };
}

const customFilterService = new CustomFilterService();

export default customFilterService;
